export default "__VITE_ASSET__q2H$6F2h__"